<template>
  <div class="login_celll">
    <template v-if="login_type == 'c'">
      <canvas ref="qrCanvas" class="canvas_cell"></canvas>
    </template>

    <img
      src="@/assets/login/login_account.png"
      alt=""
      class="login_type_icon"
      @click="login_type = 'a'"
      v-if="login_type == 'c'"
    />
    <img
      src="@/assets/login/login_code.png"
      alt=""
      class="login_type_icon"
      @click="login_type = 'c'"
      v-else
    />

    <div class="login_header">
      <div class="login_header_item" @click="selectuser('ua')">
        <p :class="{ selected: user_type == 'ua' }">用户登录</p>
        <div class="line" :style="{ opacity: user_type == 'ua' ? 1 : 0 }"></div>
      </div>
      <div class="login_header_item" @click="selectuser('ca')">
        <p :class="{ selected: user_type == 'ca' }">城市合伙人登录</p>
        <div class="line" :style="{ opacity: user_type == 'ca' ? 1 : 0 }"></div>
      </div>
    </div>

    <!-- 扫码登录 -->
    <div class="form_cell" v-if="login_type == 'c'">
      <div class="scantip">
        <span>打开</span>
        <span style="color: #333">大事纪APP</span>
        <span>扫码登录</span>
      </div>
      <div class="code_cell" @click="reflashCode">
        <div class="no_effective" v-if="is_nouse_qrcode <= 0">
          <i
            class="iconfont icon-shuaxin"
            :style="{ transform: `rotate(${is_reflash ? '0' : '360deg'})` }"
          ></i>
          <span>二维码已失效，点击刷新</span>
        </div>
        <!-- <img :src="qrcode" alt="" class="ercode" /> -->
      </div>
    </div>

    <div class="form_cell" id="form_cell" v-else>
      <!-- 账号密码 -->
      <template v-if="login_type == 'a'">
        <input
          type="text"
          placeholder="大事纪ID号"
          class="account"
          :class="{ focusE: focusEle == 'account' }"
          @focus="focusEle = 'account'"
          @blur="focusEle = ''"
          v-model="account"
        />
        <div class="password_cell" :class="{ focusE: focusEle == 'password' }">
          <input
            :type="hide_pswd ? 'password' : 'text'"
            placeholder="密码"
            class="password"
            @focus="focusEle = 'password'"
            @blur="focusEle = ''"
            v-model="password"
          />
          <i
            class="iconfont icon-yanjing-biyan"
            @click="hide_pswd = !hide_pswd"
            v-if="hide_pswd"
          ></i>
          <i
            class="iconfont icon-yanjing"
            @click="hide_pswd = !hide_pswd"
            v-else
          ></i>
        </div>
      </template>

      <!-- 手机验证码 -->
      <template v-if="login_type == 'p'">
        <input
          type="phone"
          placeholder="手机号码"
          class="account"
          :class="{ focusE: focusEle == 'account' }"
          @focus="focusEle = 'account'"
          @blur="focusEle = ''"
          v-model="account"
        />
        <div class="password_cell" :class="{ focusE: focusEle == 'password' }">
          <input
            type="text"
            placeholder="验证码"
            class="password"
            @focus="focusEle = 'password'"
            @blur="focusEle = ''"
            v-model="code"
          />
          <div class="sendcode" :class="{ disabled: countdown > 0 }">
            <span v-if="countdown > 0">({{ countdown }}s)</span>
            <span v-else @click="sendCode">发送验证码</span>
          </div>
        </div>
      </template>

      <p class="changetype" @click="changeCode">
        {{ login_type == "a" ? "短信验证码登录" : "密码登录" }}
      </p>
      <button class="loginin" @click="login">登录</button>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcode";
import router from "@/router";
import { mapState, mapMutations } from "vuex";
import { v4 as uuidv3 } from "uuid";
import CryptoJS from "crypto-js";
import {
  login,
  verifyCode,
  loginVerify,
  loginPhone,
  getuserinfo,
  getloginlogapi,
} from "@/api/user";
export default {
  name: "LoginCell",
  data() {
    return {
      user_type: "ua", //ua 用户账号密码登录    ca 城市合伙人账号密码登录
      login_type: "a", //a 账号密码   p 手机验证码   c 二维码
      hide_pswd: true,
      countdown: 0,
      countdown_time: null,
      focusEle: "",
      account: "",
      password: "",
      code: "",
      is_reflash: false,
      qrcode: "",
      is_nouse_qrcode: 60,
      scan_code_time: null,
      timer: null,
      validate_code: "",
    };
  },
  watch: {
    login_type(newVal, oldVal) {
      clearInterval(this.timer);
      this.getCode();
    },
    user_type(newVal, oldVal) {
      clearInterval(this.timer);
      this.getCode();
    },
  },
  created() {
    clearInterval(this.timer);
  },
  mounted() {},
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.countdown_time);
  },
  computed: {
    disableRightClick(event) {
      event.preventDefault();
    },

    loginDisabled() {
      if (this.login_type == "a") {
        return this.account && this.password;
      } else if (this.login_type == "p") {
        return this.account && this.code;
      } else {
        return false;
      }
    },
  },
  methods: {
    ...mapMutations(["CLEAR_STATE"]),
    getScanCodeMsg() {
      getloginlogapi({
        client_id: this.validate_code,
      })
        .then((res) => {
          if (res.data.token) {
            this.$store.commit("SET_TOKEN", res.data.token);
            this.$store.commit("SET_UID", res.data.uid);
            setTimeout(() => {
              this.getuser();
            }, 100);
          }
        })
        .catch((err) => {});
    },
    getCode() {
      if (this.login_type == "c") {
        this.$nextTick(() => {
          const canvas = this.$refs.qrCanvas;
          this.scan_code_time = Date.now();
          this.validate_code = CryptoJS.MD5(uuidv3()).toString().split("-")[0];
          QRCode.toCanvas(
            canvas,
            `http://www.dsjzg.cn/pages/index/index?scene=logQrcode&timestamp=${
              this.scan_code_time
            }&type=${this.user_type == "ua" ? 1 : 2}&validata=${
              this.validate_code
            }`,
            (error) => {
              if (error) console.error(error);
            }
          );
          clearInterval(this.timer);
          this.is_nouse_qrcode = 60;
          this.timer = setInterval(() => {
            this.is_nouse_qrcode--;
            if (this.user_type == "ua") this.getScanCodeMsg();
            if (this.is_nouse_qrcode <= 0) {
              this.scan_code_time = null;
              clearInterval(this.timer);
            }
          }, 1000);
        });
      }
    },
    // 刷新二维码
    reflashCode() {
      this.is_reflash = true;
      this.getCode();
    },
    // 获取用户资料
    getuser() {
      this.$emit("setLoginStarus", { type: true, title: "正在加载页面..." });
      if (this.user_type == "ca") {
        window.location.href = "/partner";
      } else {
        getuserinfo()
          .then((res) => {
            if (res.status == 200) {
              if (res.data.real_status) {
                this.$store.commit("SET_USER_INFO", res.data);
                this.$tencentChat.loginIn();
                router.replace("/User/Manage/Activity").catch((err) => {
                  console.log(err);
                });
              } else {
                this.CLEAR_STATE();
                this.$message.error("请先在手机上完成实名认证");
              }
            }
          })
          .catch((err) => {
            console.log(err);
            this.$message.error(err);
          })
          .finally(() => {
            this.$emit("setLoginStarus", false);
          });
      }
    },
    // 登录
    login() {
      this.$emit("setLoginStarus", { type: true, title: "正在登录..." });
      console.log(this.user_type);
      // 用户账号密码登录
      // if (this.user_type == "ua") {
      // 账号密码
      if (this.login_type == "a") {
        login({
          user_type: this.user_type,
          account: this.account,
          password: this.password,
          type: "pc",
        })
          .then((res) => {
            if (res.status == 200) {
              this.$store.commit("SET_TOKEN", res.data.token);
              // this.$store.commit("SET_USER_INFO", res.data.user_info);
              this.$store.commit("SET_UID", res.data.user_info.uid);
              setTimeout(() => {
                this.getuser();
              }, 50);
            } else {
              this.$message.error(res.msg);
              this.$emit("setLoginStarus", {
                type: false,
                title: "登录失败...",
              });
            }
          })
          .catch((err) => {
            this.$message.error(err);
            this.$emit("setLoginStarus", {
              type: false,
              title: "登录失败...",
            });
          })
          .finally(() => {
            this.$emit("setLoginStarus", {
              type: false,
              title: "",
            });
          });
      } else if (this.login_type == "p") {
        // 手机验证码
        loginPhone({
          account: this.account,
          captcha: this.code,
        })
          .then((res) => {
            if (res.status == 200) {
              setTimeout(() => {
                this.$store.commit("SET_TOKEN", res.data.token);
                // this.$store.commit("SET_USER_INFO", res.data.user_info);
                this.$store.commit("SET_UID", res.data.user_info.uid);
                setTimeout(() => {
                  this.getuser();
                }, 100);
              }, 100);
            }
          })
          .catch((err) => {
            this.$message.error(err);
          });
      }
      // }
    },
    // 发送验证码
    sendCode() {
      if (this.countdown > 0) return;
      let regex = /^1[3456789]\d{9}$/;
      if (!this.account) {
        this.$message.error("请填写手机号");
        return;
      } else if (!regex.test(this.account)) {
        this.$message.error("手机号格式不正确");
        return;
      }
      verifyCode()
        .then((res) => {
          loginVerify({
            phone: this.account,
            type: "login",
            key: res.data.key,
          })
            .then((result) => {
              this.$message.success(result.msg);

              this.countdown = 120;
              this.countdown_time = setInterval(() => {
                this.countdown--;
                if (this.countdown <= 0) {
                  this.countdown = 0;
                  clearInterval(this.countdown_time);
                }
              }, 1000);
            })
            .catch((error) => {
              this.$message.error(error);
            });
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    selectuser(e) {
      // if (e == "ca") return; //关闭城市合伙人
      this.user_type = e;
      this.account = "";
      this.password = "";
      this.code = "";
      this.countdown = 0;
      clearInterval(this.countdown_time);
    },
    changeCode() {
      this.login_type = this.login_type == "a" ? "p" : "a";
      this.account = "";
      this.password = "";
      this.code = "";
      this.countdown = 0;
      clearInterval(this.countdown_time);
    },
  },
};
</script>

<style lang="scss" scoped>
.canvas_cell {
  position: absolute;
  width: 200px;
  height: 200px;
  top: 50%;
  margin-top: -70px;
  border-radius: 6px;
  border: 1px solid #dcdee1;
}

.login_celll {
  width: 378px;
  height: 420px;
  background: #ffffff;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  position: relative;

  .login_type_icon {
    width: 68px;
    height: 68px;
    position: absolute;
    top: 0;
    right: 0;
  }

  .login_header {
    height: 102px;
    display: flex;
    align-items: center;
    justify-content: center;

    .login_header_item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 0 11px;
      cursor: pointer;

      p {
        font-size: 14px;
        color: #8d8d8f;
        line-height: 25px;
        white-space: nowrap;
        transition: 0.2s;
      }

      .selected {
        font-size: 18px;
        color: #262626;
      }

      .line {
        width: 16px;
        height: 2px;
        background: #2f75fb;
        transition: 0.2s;
      }
    }
  }

  .form_cell {
    .scantip {
      font-size: 12px;
      color: #8d8d8f;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .code_cell {
      border-radius: 6px;
      position: relative;
      width: 210px;
      height: 210px;

      margin-top: 12px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;

      .no_effective {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: rgba(255, 255, 255, 0.95);
        position: absolute;
        top: 0;
        left: 0;
        z-index: 3;

        .iconfont {
          font-size: 24px;
          color: #262626;
          margin-bottom: 10px;
          /* font-weight: bold; */
          transition: 1s;
        }

        span {
          font-size: 11px;
          color: #262626;
          /* font-weight: bold; */
        }
      }
    }

    .ercode {
      width: 90%;
      height: 90%;
    }

    .account {
      width: 308px;
      height: 40px;
      border-radius: 3px;
      border: 1px solid #dcdee1;
      font-size: 13px;
      padding-left: 12px;
      margin-bottom: 16px;
    }

    .password_cell {
      width: 308px;
      height: 40px;
      border-radius: 3px;
      border: 1px solid #dcdee1;
      display: flex;
      align-items: center;

      .password {
        flex: 1;
        height: 100%;
        border: 0;
        font-size: 13px;
        padding-left: 12px;
      }

      .password:focus {
        background: transparent;
        outline: none;
      }

      .iconfont {
        color: #69718c;
        padding: 0 12px;
        font-size: 20px;
      }

      .sendcode {
        color: #2f75fb;
        padding: 0 12px;
        cursor: pointer;
      }

      .disabled {
        color: #c0c0c0;
      }
    }

    .changetype {
      font-size: 12px;
      color: #007dff;
      margin-top: 12px;
      margin-bottom: 39px;
      cursor: pointer;
    }

    .loginin {
      width: 308px;
      height: 40px;
      border-radius: 3px;
      border: 0;
      font-size: 14px;
      color: #ffffff;
      background-color: #2f75fb;
    }

    .focusE {
      border: 1px solid #4b8ffa;
    }
  }
}

::-webkit-input-placeholder {
  color: #c1c2c8;
}
</style>
